'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BUSINESS_BOOKER_USER_ROLES } from '@whitbread-eos/api';
import { formatIBAssetsUrl } from '@whitbread-eos/utils/server';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import FirstLevelNav from './FirstLevelNav/index';
import SecondLevelNav from './SecondLevelNav/index';
import { SidebarToggle } from './SidebarToggle/index';
const Sidebar = ({ menuLabels, icons, collapsed, isAccountHolder, isCardHolder, userRole })=>{
    const baseDataTestId = 'SidebarDesktop';
    const pathname = usePathname();
    const hasSecondLevel = pathname.includes('manage');
    const [isCollapsed, setIsCollapsed] = useState(hasSecondLevel || !!collapsed);
    const [previousPathname, setPreviousPathname] = useState(pathname);
    useEffect(()=>{
        if (pathname.includes('manage') && !previousPathname.includes('manage')) {
            setIsCollapsed(true);
        }
        setPreviousPathname(pathname);
    }, [
        pathname
    ]);
    const handleToggle = ()=>{
        setIsCollapsed(!isCollapsed);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: containerBaseStyle,
        "data-testid": `${baseDataTestId}-container`,
        children: [
            /*#__PURE__*/ _jsxs("nav", {
                className: fullNavContainerStyle,
                children: [
                    /*#__PURE__*/ _jsx(FirstLevelNav, {
                        menuLabels: menuLabels,
                        isAccountHolder: isAccountHolder,
                        isCardHolder: isCardHolder,
                        isCollapsed: isCollapsed
                    }),
                    hasSecondLevel && /*#__PURE__*/ _jsx(SecondLevelNav, {
                        isTravelManager: userRole === BUSINESS_BOOKER_USER_ROLES.SUPER,
                        isAccountHolder: isAccountHolder
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SidebarToggle, {
                collapseIcon: formatIBAssetsUrl(icons['icon.chevron.left.purple']),
                expandIcon: formatIBAssetsUrl(icons['icon.chevron.right.purple']),
                isCollapsed: isCollapsed,
                onToggle: handleToggle
            })
        ]
    });
};
export default Sidebar;
const fullNavContainerStyle = 'flex gap-6';
const containerBaseStyle = 'fixed flex flex-col grow-0 shrink-0 h-contentHeight top-[--headerHeight] pr-[0.938rem] pt-12 pb-9 pl-[4.125rem] border-r border-lightGrey3 bg-baseWhite z-30 mobile:hidden';
